import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthenticationGuard} from '@datev/ngx-dcal';
import {ErrorComponent} from '../error/error.component';
import {PdfViewerComponent} from './pdf-viewer.component';
import {environment} from '../../environments/environment';
export const PDF_VIEWER_PATH = 'pdf-preview';
const routes: Routes = [
  {
    path: ':appName/:nid',
    component: PdfViewerComponent,
    canActivate: [
      AuthenticationGuard
    ]
  },
  {
    path: ':appName/:nid/:docId',
    component: PdfViewerComponent,
    canActivate: [
      AuthenticationGuard
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    component: ErrorComponent,
    data: {
      header: 'FRAGEBOEGEN_APP.NOT_FOUND_ERROR.TITLE',
      message: 'FRAGEBOEGEN_APP.NOT_FOUND_ERROR.MESSAGE',
      linkLabel: 'FRAGEBOEGEN_APP.GLOBAL_ERROR.ZUR_UEBERSICHT',
      linkValue: environment.redirectPath
    }
  }
];

@NgModule({
  imports:  [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdfRoutingModule {}
